export const UUID_REGEX =
  /^[0-9a-fA-F]{8}(-|_)?[0-9a-fA-F]{4}(-|_)?4[0-9a-fA-F]{3}(-|_)?[89abAB][0-9a-fA-F]{3}(-|_)?[0-9a-fA-F]{12}\b/;
